var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"home-course-card text-light",style:(`background-image: linear-gradient(to bottom, transparent, #000A), url(${_vm.course.cover_vertical ||
      _vm.course.cover})`),attrs:{"to":{
    name: 'course',
    params: {
      ..._vm.course
    }
  }}},[_c('div',{staticClass:"content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }